import { ActionIcon, Group, Text, Stack, type MantineStyleProp, useMantineTheme } from '@mantine/core';

import ResourceAssistantChat from './ResourceAssistantChat';
import { ChevronDown } from '../../icons';

interface Props {
  onClose: () => void
  style?: MantineStyleProp
}

const ResourceAssistantDialogContent: React.FC<Props> = (props: Props) => {
  const { onClose, style } = props;
  const { colors } = useMantineTheme();
  return (
    <Stack gap={0} style={{ borderRadius: '8px', ...style }}>
      <Group
        h={50}
        justify='space-between'
        bg={colors.greyPurple[0]}
        style={{
          padding: '0px 16px',
          borderRadius: '8px 8px 0px 0px',
          border: `1px solid ${colors.gray[2]}`
        }}
      >
        <Text fw={500}>
          Resource Assistant
        </Text>
        <ActionIcon variant='subtle' onClick={onClose}>
          <ChevronDown color="#343A40" />
        </ActionIcon>
      </Group>
      <ResourceAssistantChat
        style={{ flex: 1 }}
      />
    </Stack >
  );
};

export default ResourceAssistantDialogContent;
